export const debounce = <T extends (...args: any) => Promise<any>>(f: T, wait?: number) => {
    let timer: NodeJS.Timeout | null = null;
    return (...args: Parameters<T>) => {
        if (timer != null) {
            clearTimeout(timer);
        }
        return new Promise<any>((resolve, reject) => {
            timer = setTimeout(
                () => f(...args).then(d => resolve(d)).catch(e => reject(e)),
                wait,
            );
        });
    };
}
